import type { Locale } from '@tuic/i18n';
import { CacheTag } from '../../utils';
import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { Pcl } from '../../index';
import { logger } from '@tuic/logger';

/**
 * Fetches the available ports from the PCL API.
 */
export const getPorts = async (locale: Locale): Promise<Pcl.Port[]> => {
  let { data, error } = await Pcl.getPorts({ query: { locale } });

  if (error) {
    logger.error(`Could not fetch ports. Locale: ${locale}`);
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Fetches the available ports from the PCL API.
 */
export const cachedGetPorts = (locale: Locale): Promise<Pcl.Port[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getPorts', locale]),
    () => getPorts(locale),
    {
      tags: [CacheTag.pcl, CacheTag.portResource, CacheTag.getPorts],
      ttl: 600,
    },
  );
